var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgContributionSlackLogo = function SvgContributionSlackLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.531.42a3.634 3.634 0 1 0 0 7.268h3.628V4.055A3.634 3.634 0 0 0 13.531.42m0 9.693H3.859a3.635 3.635 0 1 0 0 7.27h9.672a3.635 3.635 0 1 0 0-7.27z",
    fill: "#36C5F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.593 13.747a3.628 3.628 0 0 0-7.256 0v3.636h3.628a3.632 3.632 0 0 0 3.628-3.636zm-9.673 0V4.054a3.628 3.628 0 0 0-7.255 0v9.693a3.628 3.628 0 0 0 7.255 0z",
    fill: "#2EB67D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.292 35.782a3.634 3.634 0 1 0 0-7.268h-3.628v3.634a3.633 3.633 0 0 0 3.628 3.634zm0-9.694h9.673a3.635 3.635 0 1 0 0-7.27h-9.673a3.635 3.635 0 1 0 0 7.27z",
    fill: "#ECB22E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.231 22.454a3.628 3.628 0 0 0 7.256 0V18.82H3.859a3.631 3.631 0 0 0-3.628 3.634zm9.673 0v9.693a3.628 3.628 0 0 0 7.255 0v-9.691a3.628 3.628 0 0 0-7.255 0",
    fill: "#E01E5A"
  }))));
};
export default SvgContributionSlackLogo;